import { MedNotificationPositions } from "./types";

export const NOTIFICATION_LIFE_TIME = 5000;
export const DEFAULT_SHOW_DURATION = 200;
export const DEFAULT_HIDE_DURATION = 200;
export const DEFAULT_POSITION: MedNotificationPositions = "top-right";
